import React from "react";
import { useSelector } from "react-redux";
import { Popup } from "@progress/kendo-react-popup";
import { number, quote } from "../../../config/constants";
import config from "../../../env.config";
import { copyTextToClipboard, copyTextWithLink } from "../../../utils/common";
import { onBlur, onFocus, onOpen } from "../../../utils/kendo";
import { generateShareableFormUrl } from "../SharedForm/shareUtils";
import "./FormSharePopup.scss";

const FormSharePopup = ({ showPopup, setShowSharePopup, shareIconAnchor, formId, formName, closeCopyLinkPopup }) => {
  const showPopupRef = React.useRef(null);
  const blurShowPopupRef = React.useRef(null);
  const anchorAlign = { horizontal: "right", vertical: "bottom" };
  const app = useSelector((state) => state.app);

  /**
   * copies form name and hyperlinked form URL
   * @author Sarthak Arora
   */
  const copyFormDetailsPopup = () => {
    const linkedText = formName;
    const linkURL = generateShareableFormUrl(formId);
    copyTextWithLink("", linkedText, linkURL);
    setShowSharePopup(false);
  };

  /**
   * function used for copying Form URL
   * @author Sarthak Arora
   */
  const copyFormUrl = () => {
    const shareableFormUrl = generateShareableFormUrl(formId);
    let tenantAppUrl = app.tenantAppUrl;
    // If we have a tenant URL, use it; otherwise use the generated URL as-is
    const finalUrl = tenantAppUrl ? tenantAppUrl + `/forms/${formId}` : shareableFormUrl;
    copyTextToClipboard(finalUrl, quote.FORM_LINK_COPIED_TO_CLIPBOARD);
    setShowSharePopup(false);
  };

  return (
    <Popup
      show={showPopup}
      anchor={shareIconAnchor.current}
      onOpen={() => onOpen(showPopupRef)}
      className='position-absolute'
      anchorAlign={anchorAlign}
      popupAlign={{ horizontal: "center", vertical: "top" }}>
      <div
        id='form-share-popup'
        className='popover-item form-share-popup'
        tabIndex={number.ZERO}
        ref={showPopupRef}
        onFocus={() => onFocus(blurShowPopupRef)}
        onBlur={() => onBlur(blurShowPopupRef, closeCopyLinkPopup)}
        onClick={closeCopyLinkPopup}>
        <button
          id='form-smart-link-option'
          className='py-1 px-2'
          onClick={(e) => {
            e.stopPropagation();
            copyFormDetailsPopup();
          }}
          onMouseDown={(e) => e.stopPropagation()}>
          {quote.SMART_LINK}
        </button>
        <button
          id='form-url-option'
          className='py-1 px-2'
          onClick={(e) => {
            e.stopPropagation();
            copyFormUrl();
          }}
          onMouseDown={(e) => e.stopPropagation()}>
          {quote.URL}
        </button>
      </div>
    </Popup>
  );
};

export default FormSharePopup;
